const highlights = [
  { icon: "ri-award-line", image: "/images/kitchen/food-grade-steel.webp", title: "Food-Grade Stainless Steel", desc: "All fabrications use 304 & 316 grade steel — hygienic, corrosion-resistant, and built for lifetime performance." },
  { icon: "ri-ruler-2-line", image: "/images/kitchen/custom-design.webp", title: "Custom-Built to Your Space", desc: "Every kitchen is measured, designed, and fabricated to exact specifications so nothing is off-the-shelf." },
  { icon: "ri-shield-check-line", image: "/images/kitchen/worktops.webp", title: "Certified & Compliant", desc: "All our kitchens meet Kenya Bureau of Standards and international food safety standards." },
  { icon: "ri-settings-4-line", image: "/images/kitchen/installation-team.webp", title: "Full Turnkey Service", desc: "We handle everything — design, fabrication, delivery, installation, and post-installation support." },
];

export default function KitchenOverview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Two-column intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <span className="text-teal-600 text-xs font-semibold uppercase tracking-widest mb-3 block">Who We Are</span>
            <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold uppercase tracking-tight leading-tight mb-6">
              Precision-Crafted<br />
              <span className="text-teal-600">Kitchen Systems</span>
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              ISMAN Engineering has been the backbone of Kenya&apos;s commercial kitchen industry for over 15 years. We partner with restaurants, hotels, schools, hospitals, and catering businesses to deliver world-class kitchen environments — fabricated in-house and installed by our expert team.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              Our in-house fabrication workshop means you get direct quality control, faster delivery, and competitive pricing. No middlemen. No shortcuts. Just beautiful, functional kitchens built to last.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="#process"
                onClick={(e) => { e.preventDefault(); document.querySelector("#process")?.scrollIntoView({ behavior: "smooth" }); }}
                className="bg-teal-600 hover:bg-teal-500 text-white font-bold px-6 py-2.5 rounded-md text-sm uppercase tracking-wider transition-colors cursor-pointer whitespace-nowrap"
              >
                How We Work
              </a>
              <a
                href="tel:0724114555"
                className="border border-gray-200 hover:border-teal-400 text-gray-700 hover:text-teal-600 font-semibold px-6 py-2.5 rounded-md text-sm uppercase tracking-wider transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-phone-line"></i>
                Call Us Now
              </a>
            </div>
          </div>

          <div className="relative">
            <img
              src="/images/kitchen/installation-team.webp"
              alt="Kitchen Fabrication Workshop"
              className="w-full h-80 object-cover object-center rounded-lg"
            />
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white rounded-lg p-5 shadow-none">
              <p className="text-3xl font-extrabold">500+</p>
              <p className="text-teal-100 text-xs uppercase tracking-wide mt-1">Kitchens Delivered</p>
            </div>
          </div>
        </div>

        {/* Highlights grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((h, i) => (
            <div key={i} className="border border-gray-100 rounded-lg hover:border-teal-200 transition-colors group overflow-hidden">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
                <img src={h.image} alt={h.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-lg mb-4 group-hover:bg-teal-600 transition-colors duration-300">
                <i className={`${h.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-gray-900 font-bold text-sm uppercase tracking-wide mb-2">{h.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
